import React from "react"
import { UncontrolledTooltip } from "reactstrap"
import FontAwesome from "react-fontawesome"
import "./HelpTooltip.scss"
import PropTypes from "prop-types"

class HelpTooltip extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      readyForHover: false,
    }
  }

  componentDidMount() {
    this.componentElement &&
      this.hoverableElement &&
      this.setState({
        readyForHover: true,
      })
  }

  render() {
    const { children, placement, className } = this.props

    return (
      <span
        ref={el => (this.componentElement = el)}
        className={`${className || ""} HelpTooltip`}
      >
        <span
          className="hoverable"
          ref={el => {
            this.hoverableElement = el
          }}
        >
          <FontAwesome name="question-circle" />
        </span>
        {this.state.readyForHover && (
          <UncontrolledTooltip
            placement={placement}
            container={this.componentElement}
            target={this.hoverableElement}
            autohide={false} // don't hide tooltip when hovering over tooltip conten
          >
            {children}
          </UncontrolledTooltip>
        )}
      </span>
    )
  }
}

HelpTooltip.propTypes = {
  placement: PropTypes.oneOf([
    "auto",
    "auto-start",
    "auto-end",
    "top",
    "top-start",
    "top-end",
    "right",
    "right-start",
    "right-end",
    "bottom",
    "bottom-start",
    "bottom-end",
    "left",
    "left-start",
    "left-end",
  ]),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  className: PropTypes.string,
}

HelpTooltip.defaultProps = {
  placement: "top",
}

export default HelpTooltip
